import { render, staticRenderFns } from "./TableSort.vue?vue&type=template&id=4188c780&scoped=true"
import script from "./TableSort.vue?vue&type=script&lang=js"
export * from "./TableSort.vue?vue&type=script&lang=js"
import style0 from "./TableSort.vue?vue&type=style&index=0&id=4188c780&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188c780",
  null
  
)

export default component.exports